<template>
	<div>

		<v-autocomplete
			outline
			hide-details
			hide
			ref="search_fast_nav"
			prepend-inner-icon="search"
			:placeholder="placeholder"
			:items="items"
			v-model="selected"
			:loading="loading"
			:search-input.sync="search_value"
			@focus="is_focused = true"
			@blur="is_focused = false"
			:filter="filterData"
			:menu-props="{'max-width': 600}"
			item-text="name"
			item-value="link_to"
			class="dense_input search-input"
			autocomplete>
			<template slot="no-data">
				<v-list-tile class="background darken-2">
					<v-list-tile-title>
						Rechercher une page Gravity
					</v-list-tile-title>
				</v-list-tile>
			</template>
			<template v-slot:item="{ item }">
				<v-list-tile
					class="background darken-1"
					:to="item.link_to"
					:disabled="item.disabled">
					<v-list-tile-action v-if="item.query_key">
						<v-chip label color="background lighten-1" class="text-uppercase">
							{{ item.query_key }}
						</v-chip>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="white--text">
							{{ item.name || '-' }}
						</v-list-tile-title>
						<v-list-tile-sub-title>
							{{ item.description || '-' }}
						</v-list-tile-sub-title>
					</v-list-tile-content>
					<v-list-tile-action>
						<v-chip
							label small outline
							color="primary"
							v-if="item.is_new">
							Nouveau
						</v-chip>
					</v-list-tile-action>
				</v-list-tile>
			</template>
		</v-autocomplete>

	</div>
</template>

<script>
import { debounce } from 'debounce'
export default {
	data () {
		return {
			loading: false,
			selected: null,
			search_value: null,
			is_focused: false,
			items: [],
			routes: []
		}
	},
	computed: {
		placeholder () {
			let placeholder = '[Ctrl+Espace]'
			if (this.is_focused) {
				placeholder += '  job:  form:  jd: '
			}
			return placeholder
		}
	},
	watch: {
		$route () {
			this.search_value = false
			this.blur()
		},
		search_value (val) {
			if (!val) {
				this.items = []
				return
			}
			this.items = this.routes
			if (val.indexOf(':') > -1) {
				let query = val.replace(/ /g, '').toLowerCase()
				let value = query.split(':')[1]
				if (query.indexOf('job:') === 0) {
					if (!value) value = NaN
					this.onJobSearch(value)
				} else if (query.indexOf('form:') === 0) {
					if (!value) value = NaN
					this.onFormSearch(value)
				} else if (query.indexOf('jd:') === 0) {
					this.onJdSearch(value)
				}
			}
		}
	},
	methods: {
		focus () {
			try {
				this.$refs.search_fast_nav.focus()
			} catch (error) {
				console.log(error)
			}
		},
		blur () {
			try {
				this.$refs.search_fast_nav.blur()
			} catch (error) {
				console.log(error)
			}
		},
		onShortKey () {
			if (this.is_focused) {
				this.blur()
			} else {
				this.focus()
			}
		},
		filterData (item, queryText, itemText) {
			if (queryText === null || queryText === undefined) queryText = ''
			if (itemText === null || itemText === undefined) itemText = ''
			if (itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1) {
				return true
			}
			if (item.description) {
				if (item.description.toLowerCase().indexOf(queryText.toLowerCase()) > -1) {
					return true
				}
			}
			if (item.query_key) {
				let query_key = item.query_key.toLowerCase()
				let query_text = queryText.toLowerCase()
				query_text = query_text.replace(/ /g, '')
				query_text = query_text.split(':')[0]
				return query_key.indexOf(query_text) > -1
			}
			return false
		},
		onJobSearch (value) {
			let childMenu = {
				name: `Job Maestro #${value || '••••••'}`,
				description: 'Page de detail du job Maestro',
				query_key: 'job',
				is_new: false,
				disabled: isNaN(Number(value)),
				link_to: {
					name: 'Maestro jobs',
					query: {
						jr_id: value
					}
				}
			}
			this.items = [childMenu]
		},
		onFormSearch (value) {
			let childMenu = {
				name: `Formulaire Maestro #${value || '••••••'}`,
				description: 'Formulaire de la tâche Maestro',
				query_key: 'form',
				is_new: false,
				disabled: isNaN(Number(value)),
				link_to: {
					name: 'Maestro Forms',
					params: {
						id: value
					}
				}
			}
			this.items = [childMenu]
		},
		onJdSearch: debounce(function (value) {
			if (!value) {
				this.items = []
				return
			}
			this.loading = true
			this.$EsMaestro.jobdescriptor_list_light_search(value)
				.then(results => {
					this.items = results.map(res => {
						return {
							name: res.label,
							description: res.description,
							query_key: 'jd',
							is_new: false,
							disabled: false,
							link_to: {
								name: 'Maestro jobs',
								query: {
									job_descriptor_id: res.id
								}
							}
						}
					})
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading = false
				})
		}, 500),
		getRoutes () {
			this.$router.options.routes.map(route => {
				if (route.children) {
					route.children.map(child => {
						if (!child.meta.disabled) {
							let linkTo = { name: child.name }
							if (child.params) linkTo.params = child.params
							if (child.query) linkTo.query = child.query
							if (child.props) linkTo.props = child.props
							let childMenu = {
								route_name: route.meta.label,
								route_icon: route.meta.icon,
								route_description: route.meta.description,
								name: child.meta.label,
								icon: child.meta.icon,
								description: child.meta.description,
								is_new: child.meta.is_new,
								link_to: linkTo
							}
							this.routes.push(childMenu)
						}
					})
				}
			})
		},
		getUSerShortcuts () {
			try {
				let data = window.localStorage.getItem('home_links')
				if (data) {
					data = JSON.parse(data)
					if (Array.isArray(data)) {
						this.routes = [...this.routes, ...data]
					} else {
						// backward home 1.0 compatibility
						for (const position in data) {
							for (const section in data[position]) {
								for (const routeName in data[position][section]) {
									let route = data[position][section][routeName]
									let linkTo = { path: route.path }
									if (route.params) linkTo.params = route.params
									if (route.query) linkTo.query = route.query
									if (route.props) linkTo.props = route.props
									let childMenu = {
										name: routeName,
										description: route.meta.description,
										link_to: linkTo
									}
									this.routes.push(childMenu)
								}
							}
						}
					}
				}
			} catch (error) {
				console.log(error)
			}
		}
	},
	created () {
		this.getRoutes()
		this.getUSerShortcuts()
		window.addEventListener('keydown', (event) => {
			if (event.ctrlKey && event.code === 'Space') {
				this.onShortKey()
			}
		})
	}
}
</script>

<style lang="stylus" scoped>
.search-input
	min-width: 140px
	width: 140px
	margin-top: 0
	transition: width 0.1s ease-in
	>>>.v-input__slot
		margin: 0
		background-color: var(--v-background-darken2) !important
		border: 1px solid var(--v-background-lighten2) !important
	>>>.v-input__prepend-inner
		margin-top: 4px !important
		margin-left: 4px !important
		.v-icon
			color: var(--v-background-lighten4) !important
	>>>input
		top: 0 !important
	>>>.v-input__icon--append
		display: none

.search-input.v-input--is-focused
	transition: width 0.1s ease-in
	min-width: 500px
	width: 600px

>>>.v-list
	background-color: var(--v-background-darken1) !important
	.v-list__tile
		border-bottom: 1px solid var(--v-background-lighten1)
	.v-list__tile--highlighted
	.v-list__tile:hover
		background: var(--v-background-base) !important
</style>



// WEBPACK FOOTER //
// src/App_search.vue